import { Box } from '@material-ui/core'
import React from 'react'
import styled from 'styled-components'

const Text = styled.div`
  font-family: 'imlregular';
  color: var(--first);
  margin-bottom: .2em;
  span {
    color: var(--second);
    margin-right: .5em;
  }
`

const LinkStyled = styled.a`
  color: var(--second);
  text-decoration: none;
`

const DataDeposito = props => {
  return (
    <Box p={2}>
      <Text>Servicios Clínicos Especializados IML S.A. DE C.V.</Text>
      <Text><span>INSTITUCION BANCARIA:</span>Banamex</Text>
      <Text><span>CUENTA:</span>1386005 | <span>SUCURSAL:</span> 7010</Text>
      <Text><span>CLABE:</span>002680701013860051</Text>
      <Box mt={3} />
      <Text>
        RECUERDA ENVIAR TU COMPROBANTE DE PAGO AL WHATSAPP <LinkStyled target='_blank' href='https://api.whatsapp.com/send?phone=5214428173500'>(442) 817 3500</LinkStyled>
      </Text>
    </Box>
  )
}

export default DataDeposito
